import crypto from 'crypto';
import {Roles, User} from '../store/api/apiTypes';
import {ObjectUtils} from './object-utils';
import {ArrayUtils} from './array-utils';
import {StringUtils} from './string-utils';

export class Encryption {
  private static readonly HASH = 'sha512';
  private static readonly HEX = 'hex';
  private static readonly UTF8 = 'utf8';
  private static readonly BASE64 = 'base64';
  private readonly KEY!: any;
  private readonly ENCRYPTION_IV!: any;

  constructor(private configuration: {
    secretKey: string | undefined,
    secretIv: string | undefined,
    encryptionMethod: string | undefined,
  }) {
    this.KEY = crypto
      .createHash(Encryption.HASH)
      .update(this.configuration.secretKey!)
      .digest(Encryption.HEX)
      .substring(0, 32);
    this.ENCRYPTION_IV = crypto
      .createHash(Encryption.HASH)
      .update(this.configuration.secretIv!)
      .digest(Encryption.HEX)
      .substring(0, 16);
  }

  public decryptData(encryptedData: string | undefined): string {
    if (ObjectUtils.isNullOrUndefined(encryptedData)) {
      return StringUtils.EMPTY;
    }
    try {
      const buff = Buffer.from(encryptedData!, Encryption.BASE64);
      const decipher = crypto.createDecipheriv(this.configuration.encryptionMethod!, this.KEY, this.ENCRYPTION_IV);
      const decipherUpdate = decipher.update(buff.toString(Encryption.UTF8), Encryption.HEX, Encryption.UTF8);
      const decipherFinal = decipher.final(Encryption.UTF8);
      return decipherUpdate + decipherFinal;
    } catch (exception) {
      return encryptedData!;
    }
  }

  public decryptUser(user: User | undefined): User | undefined {
    if (ObjectUtils.isNullOrUndefined(user)) {
      return user;
    }
    const oldPasswords = !ObjectUtils.isNullOrUndefined(user!.oldPasswords)
      ? user!.oldPasswords!.map((oldPassword) => this.decryptData(oldPassword))
      : ArrayUtils.empty();
    return {
      createdAt: user!.createdAt,
      email: this.decryptData(user!.email),
      firstName: this.decryptData(user!.firstName),
      id: user!.id,
      lastName: this.decryptData(user!.lastName),
      password: this.decryptData(user!.password),
      phone: this.decryptData(user!.phone),
      position: this.decryptData(user!.position),
      role: this.decryptData(user!.role) as Roles,
      oldPasswords,
    };
  }
}
